export function formatInterval(intervalInMinutes: number) {
    if (intervalInMinutes < 60)
        return Math.floor(intervalInMinutes) + 'm';

    const intervalInHours = Math.floor(intervalInMinutes / 60);
    if (intervalInHours < 24)
        return intervalInHours + 'h';

    return Math.floor(intervalInHours / 24) + 'd';
}